export default __webpack_public_path__ + "static/media/animation1.aba71f21.gif";